import { defineStore } from 'pinia'
import axios from 'axios'

function normalizeMenuItem(node) {
	const url = node.url || ''
	const isHttp = /^https?:\/\//i.test(url)
	const isRealLink = url !== '' && url !== '#'
	const openBlank = node.target === '_blank'

	let type = 'label' // non-clickable trigger (covers '' and '#')
	if (isRealLink && (isHttp || openBlank)) type = 'external'
	else if (isRealLink) type = 'router' // internal SPA path

	return {
		label: node.title,
		to: type === 'router' ? url : null, // path string; router resolves it
		href: type === 'external' ? url : null,
		target: node.target || '_self',
		type,
		showIcon: type === 'external' && openBlank, // outbound icon only
		children: (node.children || []).map(normalizeMenuItem),
	}
}

export const useGlobalStore = defineStore('global', {
	state: () => {
		return {
			mobile: false,
			cart: false,
			modal: {
				name: null,
				payload: null,
				canClose: true,
			},
			countries: [],
			games: [],
			tournaments: [],
			videos: [],
			content: {},
			pages: [],
			menu: [],
		}
	},
	getters: {
		menuTree: (state) => state.menu.map(normalizeMenuItem),
	},
	actions: {
		toggleMobile(delta) {
			delta != null ? (this.mobile = delta) : (this.mobile = !this.mobile)
		},
		setup() {
			this.getCountries()
			this.getGames()
			this.getTournaments()
			this.getVideos()
			this.getContent()
			this.getPages()
			this.getMenu()
		},
		getMenu() {
			return axios
				.get('/api/menu')
				.then((menu) => {
					this.menu = menu.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getCountries() {
			return axios
				.get('/api/countries')
				.then((countries) => {
					this.countries = countries.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getGames() {
			return axios
				.get('/api/games')
				.then((games) => {
					this.games = games.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getTournaments() {
			return axios
				.get('/api/tournament')
				.then((tournaments) => {
					this.tournaments = tournaments.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getVideos() {
			return axios
				.get('/api/videos')
				.then((videos) => {
					this.videos = videos.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getContent() {
			return axios
				.get('/api/content')
				.then((content) => {
					this.content = content.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getPages() {
			return axios
				.get('/api/pages')
				.then((pages) => {
					this.pages = pages.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		openModal(modal) {
			this.modal = {
				name: modal,
				payload: null,
				canClose: true,
			}
			document.body.classList.add('overflow-hidden')
		},
		setModal(modal) {
			this.modal = {
				name: modal[0],
				payload: modal[1],
				canClose: modal[2] ?? true,
			}
			document.body.classList.add('overflow-hidden')
		},
		closeModal() {
			this.modal = {
				name: null,
				payload: null,
				canClose: true,
			}
			document.body.classList.remove('overflow-hidden')
		},
	},
})
